import "./Home.css"
import image from "../../imgs/habib.jpg"
import cv from '../../imgs/cv.pdf'

const Home = () => {
  return (
    <>
      <div className="home d-flex flex-column justify-content-center align-items-center text-center">
        <h1>WELCOME TO MY PORTFOLIO</h1>
        <img src={image} alt="habib" className="HomeImg mt-3" />
        <div >
          <h2 className="mt-4">
            Junior Front-End Developer <br /> Algebra & Cryptography Enthusiast
          </h2>
          <p className="mt-4">
            Hello! I'm <span>Begua Maamar Elhabib</span>, a junior front-end developer passionate about blending creativity with technical expertise. Currently studying Algebra and Cryptography at USTHB, I enjoy solving mathematical puzzles and crafting elegant web solutions. Let's create something amazing together!
          </p>
          <a href={cv} download>
            <button className="mt-3">Download my cv</button>
          </a>
        </div>

      </div>
    </>
  )
}

export default Home